export const SYNC_PLATFORM_CONFIG_TO_GITHUB_URL = '/aic_one_api/system_management/api/sync-platform-config-to-github/';
export const SYNC_PLATFORM_CONFIG_TO_CICD_URL = '/aic_one_api/system_management/api/sync-platform-config-to-cicd/';

export const MICROSOFT_MARKETPLACE_ENDPOINTS = Object.freeze({
  activation_details: '/aic_one_api/microsoft_sso/api/marketplace_activation_details_api/',
  buyer_context: '/aic_one_api/microsoft_sso/api/marketplace_buyer_context_api/',
  submit_setup_request: '/aic_one_api/microsoft_sso/api/marketplace_submit_setup_request_api/',
  setup_status: '/aic_one_api/microsoft_sso/api/marketplace_setup_status_api/',
  microsoft_login: '/aic_one_api/microsoft_sso/api/microsoft_login_api/',
  microsoft_signup: '/aic_one_api/microsoft_sso/api/microsoft_signup_api/',
});

export const SYSTEM_MANAGEMENT_ENDPOINTS = Object.freeze({
  get_platforms: '/aic_one_api/system_management/get_platforms/',
  get_user_platform_access: '/aic_one_api/system_management/get_user_platform_access/',
  set_user_platform_access: '/aic_one_api/system_management/set_user_platform_access/',
  get_platform_configs: '/aic_one_api/system_management/api/get_platform_configs_api/',
  create_platform: '/aic_one_api/system_management/api/add_platform_api/',
  create_platform_config: '/aic_one_api/system_management/api/add_platform_config_api/',
  assign_platform_access: '/aic_one_api/system_management/api/assign_platform_access_api/',
  get_platform_access_assignments: '/aic_one_api/system_management/api/get_platform_access_assignments_api/',
  get_platform_deployment_checklist: '/aic_one_api/system_management/api/get_platform_deployment_checklist_api/',
  platform_config_deployment_handover: '/aic_one_api/system_management/api/platform_config_deployment_handover/',
  reveal_platform_config_deployment_values: '/aic_one_api/system_management/api/reveal_platform_config_deployment_values/',
  platform_readiness_check: '/aic_one_api/system_management/api/platform_readiness_check_api/',
  launch_configured_platform: '/aic_one_api/system_management/api/launch_configured_platform_api/',
  get_csrf_token: '/aic_one_api/system_management/get_csrf_token/',
  save_push_subscription: '/aic_one_api/one_chat_management/api/save_push_subscription_api/',
  push_heartbeat: '/aic_one_api/one_chat_management/api/chat_heartbeat_api/',
  mark_push_offline: '/aic_one_api/one_chat_management/api/mark_chat_offline_api/',
  prepare_playground: '/aic_one_api/playground/prepare_playground/',
  prepare_playground_platform_session: '/aic_one_api/playground/prepare_playground_platform_session/',
  sync_platform_config_to_github: SYNC_PLATFORM_CONFIG_TO_GITHUB_URL,
  sync_platform_config_to_cicd: SYNC_PLATFORM_CONFIG_TO_CICD_URL,
});

export function build_system_management_url(endpoint_path) {
  return `${process.env.VUE_APP_API_BASE_URL}${endpoint_path}`;
}

export function build_microsoft_marketplace_url(endpoint_path) {
  return `${process.env.VUE_APP_API_BASE_URL}${endpoint_path}`;
}
